import * as XLSX from "xlsx-js-style";

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const ESTADO_FILL = {
  'PRE-APROBADO': { fgColor: { rgb: "FEF3C7" }, font: { rgb: "92400E" } },
  'APROBADO': { fgColor: { rgb: "D1FAE5" }, font: { rgb: "065F46" } },
};

const HEADERS = [
  "Vendedor", "Bodega", "Cédula", "Nombre Completo", "N° Solicitud",
  "Fecha", "Estado", "Verificación Documental", "Verificación Telefónica",
];

// Exporta la lista de créditos aprobados/pre-aprobados a Excel. Sirve para los
// 3 alcances (vendedor / bodega / todos) sin distinción: el SP siempre trae
// NombreVendedor y NombreBodega, sin importar qué filtro se haya aplicado.
export function exportarClientesAprobadosExcel(rows, titulo) {
  if (!rows || rows.length === 0) return;

  const ws_data = [HEADERS];
  rows.forEach(row => {
    ws_data.push([
      row.NombreVendedor || '—',
      row.NombreBodega || '—',
      row.Cedula || '—',
      row.NombreCompleto || '—',
      row.NumeroSolicitud || '—',
      formatDate(row.Fecha),
      row.Estado || '—',
      row.VerificacionDocumental || '—',
      row.VerificacionTelefonica || '—',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(ws_data);
  const range = XLSX.utils.decode_range(ws['!ref']);

  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
      if (!ws[cell_ref]) continue;

      ws[cell_ref].s = {
        alignment: { vertical: "center", horizontal: C === 3 ? "left" : "center" },
        border: {
          top: { style: "thin", color: { auto: 1 } },
          bottom: { style: "thin", color: { auto: 1 } },
          left: { style: "thin", color: { auto: 1 } },
          right: { style: "thin", color: { auto: 1 } },
        },
      };

      if (R === 0) {
        ws[cell_ref].s.font = { bold: true, color: { rgb: "FFFFFF" } };
        ws[cell_ref].s.fill = { fgColor: { rgb: "2D3689" } };
      } else if (C === 6) {
        const estadoStyle = ESTADO_FILL[ws[cell_ref].v];
        if (estadoStyle) {
          ws[cell_ref].s.fill = { fgColor: estadoStyle.fgColor };
          ws[cell_ref].s.font = { bold: true, color: estadoStyle.font };
        }
      }
    }
  }

  ws['!cols'] = [
    { wch: 26 }, { wch: 22 }, { wch: 14 }, { wch: 32 }, { wch: 14 },
    { wch: 12 }, { wch: 14 }, { wch: 22 }, { wch: 22 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Clientes Aprobados");
  XLSX.writeFile(wb, `${titulo}.xlsx`);
}
